import { Typography } from "@material-ui/core";
import { memo } from "react";

import { Grid } from "../../../components/Grid";

import style from "./SummaryRow.module.scss";

type SummaryRowProps = {
  name: string;
  value: string | string[] | null;
};

const normalizeToArray = (v: string | string[] | null): string[] =>
  Array.isArray(v) ? v : v ? [v] : [];

const isUrlLike = (v: string): boolean => {
  return (
    /^(https?:\/\/|mailto:|tel:|ftp:\/\/|blob:|data:)/i.test(v) ||
    v.startsWith("/")
  );
};

const renderItem = (value: string, index: number) => {
  if (isUrlLike(value)) {
    return (
      <a
        key={`${value}-${index}`}
        className={style["value-item"]}
        href={value}
        target="_blank"
        rel="noreferrer"
      >
        Załącznik {index + 1}
      </a>
    );
  }
  return (
    <span key={`${value}-${index}`} className={style["value-item"]}>
      {value}
    </span>
  );
};

export const SummaryRow = memo<SummaryRowProps>(({ name, value }) => (
  <Grid container className={style.container}>
    <Grid item xs={12} md={4} spacingInnerRight={5}>
      <Typography>{name}</Typography>
    </Grid>
    <Grid item className={style["value-container"]} xs={12} md={8}>
      <Typography>
        {normalizeToArray(value).map((v, i) => renderItem(v, i))}
      </Typography>
    </Grid>
  </Grid>
));
